import { useState } from "react"
import ReturnParams from "./returnParams"
import { useSetRecoilState } from "recoil"
import { useNavigate } from "react-router-dom"
import { AlertState } from "schemas"
import { HttpStatus } from "schemas"
import { DrawerSchema, initialDrawerState } from "schemas"

export function GeneralFetch() {
    const baseURL = /*'http://127.0.0.1:8000/api/'*/'https://nearmiss.5enta.org/api/api/'
    const navigate = useNavigate()

    const setAlert = useSetRecoilState(AlertState)
    const setStatus = useSetRecoilState(HttpStatus)
    const setOpen = useSetRecoilState(DrawerSchema)
    const [loading, setLoad] = useState(false)
    const [data, setData] = useState([])
    const { getParams } = ReturnParams({ setLoad })

    async function fetchData(obj, endPoint, method, object) {
        try {
            const response = await fetch(baseURL + endPoint, getParams(method, obj, (endPoint === 'upload' || endPoint === 'updateStatus')))
            setStatus(response.status)

            const contentType = response.headers.get("content-type") || ""
            const data = contentType.includes("application/json")
                ? await response.json()
                : { error: await response.text() || "O servidor devolveu uma resposta inválida." }

            if (!response.ok && !data?.error && !data?.warning) {
                data.error = `Não foi possível concluir o pedido (${response.status}).`
            }

            if (data?.message?.includes('Unauthenticated') || (data?.message?.toLowerCase()?.includes("token") && data?.message?.toLowerCase()?.includes("expired"))) {
                setOpen(initialDrawerState)
                navigate("/Unauthenticated")
            } else {
                if (data.error || data.warning || data.success) {
                    if (data?.validation === true) {
                        const key = Object.keys(data?.warning || {})
                        setAlert(alert => ({ ...alert, type: 'warning', msg: data?.warning?.[key[0]]?.[0] }))
                    } else {
                        const responseKey = Object.keys(data)[0]
                        setAlert(alert => ({ ...alert, type: responseKey, msg: data[responseKey] }))
                    }
                    setData(Object.prototype.hasOwnProperty.call(data, 'success'))
                } else if (!data?.expception && object) {
                    setData(data?.[object] ?? data)
                }
                return data
            }
        } catch (error) {
            setAlert(alert => ({
                ...alert,
                type: 'error',
                msg: error?.message || 'Não foi possível comunicar com o servidor.'
            }))
            throw error
        } finally {
            setLoad(false)
        }
    }

    return { fetchData, loading, data }
}
